import { $host } from "./index";

export const createClinicService = async (service) => {
  const { data } = await $host.post('web/services/', service);
  return data;
}

export const reorderServices = async (services) => {
  console.log(services)
  const { data } = await $host.post('web/services/reorder', services);
  return data;
}

export const getServicesList = async (clinicId) => {
  const { data } = await $host.get(`web/services/${clinicId}`);
  return data;
}

export const createCollageService = async (collage) => {
  const { data } = await $host.post('web/services/collage', collage);
  return data;
}

export const fetchServices = async (clinicId) => {
  const {data} = await $host.post(`web/services/getServices/${clinicId}`);
  return data;
}

export const getServicesForCollage = async (clinicId) => {
  const {data} = await $host.post(`web/services/getServicesForCollage/${clinicId}`);
  return data;
}

export const deleteClinicService = async (id) => {
  const { data } = await $host.delete(`web/services/${id}`);
  return data;
}

export const fetchOneService = async (id) => {
    const {data} = await $host.get(`web/services/${id}`);
    return data;
}

export const getCollages = async (clinicId) => {
  const { data } = await $host.get(`web/services/collages/${clinicId}`);
  return data;
}

export const fetchOneCollage = async (id) => {
  const { data } = await $host.get(`web/services/collage/${id}`);
  return data;
}

export const deleteCollage = async (id) => {
  const { data } = await $host.delete(`web/services/collage/${id}`);
  return data;
}